export default __webpack_public_path__ + "static/events-ideas-food-82de9203a87ec05e8e3b5fca38cd4551.jpg";